/**
 * Variant-level product images: media alt text contains comma-separated variant IDs.
 * Opt-in per product via tag: variant-level-images
 */
(function () {
  'use strict';

  function parseAltTokens(alt) {
    if (!alt) return [];
    return alt
      .split(',')
      .map(function (t) {
        return t.trim().replace(/^vid:/i, '').trim();
      })
      .filter(Boolean);
  }

  function altMatchesVariant(alt, variantId) {
    var id = String(variantId);
    return parseAltTokens(alt).some(function (token) {
      return token === id;
    });
  }

  function getSlideAlt(slide) {
    if (slide.dataset.vliAlt) return slide.dataset.vliAlt;
    var img = slide.querySelector('img');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function filterElements(elements, variantId) {
    var visible = 0;
    elements.forEach(function (el) {
      var alt = el.dataset.vliAlt || getSlideAlt(el);
      var match = altMatchesVariant(alt, variantId);
      el.style.display = match ? '' : 'none';
      el.hidden = !match;
      el.classList.toggle('vli-hidden', !match);
      if (match) visible += 1;
    });
    /* Fallback: media alts without variant IDs would hide every slide */
    if (visible === 0 && elements.length) {
      var first = elements[0];
      first.style.display = '';
      first.hidden = false;
      first.classList.remove('vli-hidden');
      visible = 1;
    }
    return visible;
  }

  function updateSwiper(gallery) {
    var main = gallery.querySelector('.parent-slider');
    if (!main || !main.swiper) return;
    main.swiper.update();
    main.swiper.slideTo(0, 0);
    var thumb = gallery.querySelector('.thumb-slider');
    if (thumb && thumb.swiper) {
      thumb.swiper.update();
      thumb.swiper.slideTo(0, 0);
    }
  }

  function filterGallery(gallery, variantId) {
    if (!gallery) return;
    var selector =
      gallery.dataset.vliSlideSelector ||
      '.swiper-slide[data-vli-alt], .product-gallery__item[data-vli-alt], .tb-pcard__slide[data-vli-alt], img[data-vli-alt]';
    var slides = gallery.querySelectorAll(selector);
    if (!slides.length) return;
    filterElements(slides, variantId);
    if (gallery.querySelector('.parent-slider')) {
      updateSwiper(gallery);
    }
  }

  function getVariantIdFromInput(input) {
    if (!input) return null;
    if (input.dataset.varid) return input.dataset.varid;
    var item = input.closest('.product-variant__item');
    if (item) {
      var itemInput = item.querySelector('[data-varid]');
      if (itemInput && itemInput.dataset.varid) return itemInput.dataset.varid;
    }
    return null;
  }

  function initRoot(root) {
    var variantId = root.dataset.initialVariantId;
    if (!variantId) return;
    var gallery = root.querySelector('[data-pcard-media]') || root.querySelector('.tb-pcard__track');
    if (gallery) {
      gallery.dataset.vliSlideSelector = '.tb-pcard__slide[data-vli-alt]';
      filterGallery(gallery, variantId);
    }
  }

  function initPdpGallery() {
    var gallery = document.querySelector('[data-variant-level-images-gallery]');
    if (!gallery) return;
    var input = document.querySelector('.product-variant-value:checked');
    var variantId =
      gallery.dataset.initialVariantId ||
      (input && getVariantIdFromInput(input));
    if (variantId) filterGallery(gallery, variantId);
  }

  function filterCardRoot(root, variantId) {
    if (!root) return;
    var track = root.querySelector('[data-pcard-media]') || root.querySelector('.tb-pcard__track');
    if (!track) return;
    track.dataset.vliSlideSelector = '.tb-pcard__slide[data-vli-alt]';
    filterGallery(track, variantId);
    if (window.TypeBeautyPcardGallery && typeof window.TypeBeautyPcardGallery.resetGalleryToStart === 'function') {
      window.TypeBeautyPcardGallery.resetGalleryToStart(root);
    }
  }

  function resolveScope(scope) {
    if (!scope) return { card: null, pdp: null };
    if (scope.matches('[data-variant-level-images-gallery]')) {
      return { card: null, pdp: scope };
    }
    if (scope.matches('[data-variant-level-images]')) {
      return { card: scope, pdp: null };
    }
    var card = scope.closest('[data-variant-level-images]');
    var pdp = scope.closest('[data-variant-level-images-gallery]');
    if (!pdp) {
      var section = scope.closest('product-page, .product-page, .shopify-section');
      if (section) pdp = section.querySelector('[data-variant-level-images-gallery]');
    }
    return { card: card, pdp: pdp };
  }

  function onVariantChange(variantId, scope) {
    var resolved = resolveScope(scope);
    if (resolved.pdp) {
      filterGallery(resolved.pdp, variantId);
      return;
    }
    if (resolved.card) {
      filterCardRoot(resolved.card, variantId);
      return;
    }

    // PDP fallback when callers omit scope (e.g. legacy inline scripts)
    var gallery = document.querySelector('[data-variant-level-images-gallery]');
    if (gallery) filterGallery(gallery, variantId);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-variant-level-images]').forEach(initRoot);
    initPdpGallery();
  });

  document.addEventListener('click', function (e) {
    var variant = e.target.closest('.product-item__variant[data-varid]');
    if (!variant) return;
    var root = variant.closest('[data-variant-level-images]');
    if (!root) return;
    onVariantChange(variant.dataset.varid, root);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product-variant-value')) return;
    var variantId = getVariantIdFromInput(e.target);
    if (!variantId) return;
    var section = e.target.closest('product-page, .product-page, .shopify-section');
    var gallery =
      (section && section.querySelector('[data-variant-level-images-gallery]')) ||
      e.target.closest('[data-variant-level-images-gallery]');
    if (gallery) onVariantChange(variantId, gallery);
  });

  window.TypeBeautyVariantLevelImages = {
    altMatchesVariant: altMatchesVariant,
    filterGallery: filterGallery,
    onVariantChange: onVariantChange,
  };
})();
